<template>
    <section>
        <div class="blog-list-inner">
            <div v-for="entry in renderList" :key="entry.key">
                <article v-if="entry.kind === 'article'">
                    <header>
                        <h2>{{ entry.item.title }}</h2>
                        <blog-sub-byline
                            :author-name="entry.item.authorName"
                            :columnist-id="entry.item.columnistId"
                            :administrator-id="entry.item.administratorId"
                            :byline-date="getLatestDate(entry.item)"
                            :author-link="entry.item.authorLink"
                            :portrait-url-prop="entry.item.portraitUrl"
                            :language="language"
                        />
                    </header>

                    <gallery
                        v-if="entry.item._files && entry.item._files.length"
                        :value="entry.item._files"
                        :hide-pagination="entry.item._files.length === 1"
                        class="gallery-container"
                    />

                    <div class="article-body">
                        <div v-for="(part, pidx) in entry.item.parts" :key="pidx + '-body'">
                            <gallery
                                v-if="isGallery(part)"
                                :value="filesForPart(part)"
                                :hide-pagination="true"
                                class="gallery-container"
                            />
                            <div v-else-if="part.html" v-html="sanitizePartHtml(part.html)"></div>
                        </div>
                    </div>

                    <footer>
                        <p v-if="entry.item.source">
                            <span>{{ bundle.id_1519 }} </span>
                            <span> {{ bb(entry.item.source) }} </span>
                        </p>

                        <vatin-box
                            :advertorial="entry.item.advertorial"
                            :vatins="entry.item.articleVatinCollection"
                            :label="bundle.id_12055"
                        />
                        <article-projects :projects="entry.item.projects"/>
                    </footer>
                </article>

                <!--                Banner-->
                <div v-else-if="showBanners === 'true'" class="blog-banner-slot"
                     :class="{ 'blog-banner-slot--double': entry.banners && entry.banners.length === 2 }">
                    <div v-for="banner in entry.banners"
                        :key="banner"
                        class="blog-banner-item"
                        :data-banner="banner">
                        <template v-if="banner === 'takeover1'">
                            <small
                                id="label-regular-takeover-article-1"
                                class="mowgli-label gam-label-takeover gam-label">
                                {{ bundle.id_11005 }}
                            </small>
                            <google-ad-blog-display
                                id="regular-takeover-article-1"
                                :ad-unit-path="adUnitPathTakeover + '/regular-takeover-article-1'"
                                :topic-id="topicId"
                                :industry-id="industryId"
                                :refreshAdSlot="refreshAdSlot"
                                :sizeMapping="{
                                    large: [[980,250]],
                                    mall: [[980,250]],
                                    mobile: [[300,100]]
                                }"
                            />
                        </template>

                        <template v-else-if="banner === 'campaign1'">
                            <small
                                id="label-regular-campaign-article-1"
                                class="mowgli-label gam-label-campaign gam-label">
                                {{ bundle.id_11005 }}
                            </small>
                            <google-ad-blog-display
                                id="regular-campaign-article-1"
                                :ad-unit-path="adUnitPathCampaign + '/regular-campaign-article-1'"
                                :topic-id="topicId"
                                :industry-id="industryId"
                                :refreshAdSlot="refreshAdSlot"
                                :sizeMapping="{
                                    large: [[300,250]],
                                    small: [[300,250]],
                                    mobile: [[300,250]]
                                }"
                            />
                        </template>

                        <template v-else-if="banner === 'campaign2'">
                            <small
                                id="label-regular-campaign-article-2"
                                class="mowgli-label gam-label-campaign gam-label">
                                {{ bundle.id_11005 }}
                            </small>
                            <google-ad-blog-display
                                id="regular-campaign-article-2"
                                :ad-unit-path="adUnitPathCampaign + '/regular-campaign-article-2'"
                                :topic-id="topicId"
                                :industry-id="industryId"
                                :refreshAdSlot="refreshAdSlot"
                                :sizeMapping="{
                                    large: [[300,250]],
                                    small: [[300,250]],
                                    mobile: [[300,250]]
                                }"
                            />
                        </template>

                        <template v-else-if="banner === 'campaign3'">
                            <small
                                id="label-regular-campaign-article-3"
                                class="mowgli-label gam-label-campaign gam-label">
                                {{ bundle.id_11005 }}
                            </small>
                            <google-ad-blog-display
                                id="regular-campaign-article-3"
                                :ad-unit-path="adUnitPathCampaign + '/regular-campaign-article-3'"
                                :topic-id="topicId"
                                :industry-id="industryId"
                                :refreshAdSlot="refreshAdSlot"
                                :sizeMapping="{
                                    large: [[300,250]],
                                    small: [[300,250]],
                                    mobile: [[300,250]]
                                }"
                            />
                        </template>

                        <template v-else-if="banner === 'campaign4'">
                            <small
                                id="label-regular-campaign-article-4"
                                class="mowgli-label gam-label-campaign gam-label">
                                {{ bundle.id_11005 }}
                            </small>
                            <google-ad-blog-display
                                id="regular-campaign-article-4"
                                :ad-unit-path="adUnitPathCampaign + '/regular-campaign-article-4'"
                                :topic-id="topicId"
                                :industry-id="industryId"
                                :refreshAdSlot="refreshAdSlot"
                                :sizeMapping="{
                                    large: [[300,250]],
                                    small: [[300,250]],
                                    mobile: [[300,250]]
                                }"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";

export default {
    name: "blog-article-list",
    props: {
        articleId: {type: Number, required: true},
        language: {type: String, default: ""},
        adUnitPathCampaign: {type: String, default: ""},
        adUnitPathTakeover: {type: String, default: ""},
        topicId: {type: String, default: null},
        industryId: {type: String, default: null},
        refreshAdSlot: {type: String, default: "false"},
        showBanners: {type: String, default: "false"}
    },
    data() {
        return {
            list: [],
            loading: false,
            bundle: {
                id_1519: "Source:",
                id_11005: "Advertisement"
            },
            pollTimer: null,
            latestCreatedIso: null,
            latestUpdatedIso: null,
            iframelyObserver: null,
            iframelyTimer: null,
            iframelyPromise: null,
            isDesktop: false,
            desktopMq: null,
            includeInactive: false,
        };
    },
    created() {
        Vue.$bundle("portal", this.bundle, (bundle) => {
            this.bundle = bundle;
        });
    },
    mounted() {
        this.includeInactive = document.referrer?.includes("aptoma.no");

        this.desktopMq = window.matchMedia("(min-width: 768px)");
        this.isDesktop = this.desktopMq.matches;

        if (this.desktopMq.addEventListener) {
            this.desktopMq.addEventListener("change", this.onBreakpointChange);
        } else {
            this.desktopMq.addListener(this.onBreakpointChange);
        }

        this.setupAdListeners();

        this.loadArticles();
        this.startLiveUpdates();
        this.initTwitterEmbeds();
        
        this.scheduleIframelyRender();

        document.addEventListener("visibilitychange", this.onVisibilityChange);
    },
    beforeDestroy() {
        this.stopLiveUpdates();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);

        if (this.desktopMq) {
            if (this.desktopMq.removeEventListener) {
                this.desktopMq.removeEventListener("change", this.onBreakpointChange);
            } else {
                this.desktopMq.removeListener(this.onBreakpointChange);
            }
        }

        if (this.iframelyObserver) this.iframelyObserver.disconnect();
        this.iframelyObserver = null;
    },
    updated() {
        this.initTwitterEmbeds();
        this.scheduleIframelyRender();
    },
    computed: {
        activeList() {
            if (this.includeInactive) {
                return this.list || [];
            }

            return (this.list || []).filter(a => a && a.active);
        },
        bannerSequence() {
            return ["takeover1", "campaign1", "campaign2", "campaign3", "campaign4"];
        },
        renderList() {
            const res = [];
            let countSinceBanner = 0;

            const bannerGroups = this.isDesktop
                ? [
                    ["takeover1"],
                    ["campaign1", "campaign2"],
                    ["campaign3", "campaign4"],
                ]
                : [
                    ["takeover1"],
                    ["campaign1"],
                    ["campaign2"],
                    ["campaign3"],
                    ["campaign4"],
                ];

            let groupIndex = 0;

            this.activeList.forEach((item, idx) => {
                res.push({
                    kind: "article",
                    item,
                    key: `a-${item.id ?? idx}`,
                });

                countSinceBanner++;

                if (countSinceBanner === 2 && groupIndex < bannerGroups.length) {
                    const banners = bannerGroups[groupIndex++];
                    res.push({
                        kind: "banner",
                        banners,
                        key: `b-${banners.join("-")}-${groupIndex}`,
                    });
                    countSinceBanner = 0;
                }
            });

            while (groupIndex < bannerGroups.length) {
                const banners = bannerGroups[groupIndex++];
                res.push({
                    kind: "banner",
                    banners,
                    key: `b-${banners.join("-")}-${groupIndex}`,
                });
            }

            return res;
        },
    },
    methods: {
        bb: function (str) {
            return Vue.$bbUtil.block(str);
        },
        startLiveUpdates() {
            if (this.pollTimer) return;

            this.pollTimer = setInterval(() => {
                this.refreshArticles();
            }, 60000);
        },

        stopLiveUpdates() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
        },
        onVisibilityChange() {
            if (document.hidden) this.stopLiveUpdates();
            else {
                this.startLiveUpdates();
                this.refreshArticles();
            }
        },
        async fetchArticleList() {
            const data = await this.$services.articleService.loadBlogArticleList(this.articleId, this.latestCreatedIso, this.includeInactive);

            const arr = Array.isArray(data) ? data.filter(Boolean) : [];
            arr.sort((a, b) => new Date(b.created) - new Date(a.created));
            return arr;
        },
        mergeArticleList(incomingSorted) {
            const byId = new Map();

            for (const a of (this.list || [])) {
                if (a && a.id != null) byId.set(a.id, a);
            }

            const newItems = [];

            for (const inc of incomingSorted) {
                if (!inc) continue;

                if (inc.id == null) {
                    newItems.push(inc);
                    continue;
                }

                const prev = byId.get(inc.id);
                if (!prev) {
                    byId.set(inc.id, inc);
                    newItems.push(inc);
                } else {
                    const merged = {...prev, ...inc};
                    if (prev._files && !inc._files) merged._files = prev._files;
                    byId.set(inc.id, merged);
                }
            }

            const mergedArr = Array.from(byId.values());

            const idLessExisting = (this.list || []).filter(a => a && a.id == null);
            const idLessIncoming = incomingSorted.filter(a => a && a.id == null);
            const idLessAll = [...idLessIncoming, ...idLessExisting];

            const finalArr = [...mergedArr, ...idLessAll].filter(Boolean);
            finalArr.sort((a, b) => new Date(b.created) - new Date(a.created));

            this.list = finalArr;

            const latestCreated = finalArr
                .map(a => new Date(a.created))
                .filter(d => !isNaN(d.getTime()))
                .sort((a, b) => b - a)[0];
            this.latestCreatedIso = latestCreated ? latestCreated.toISOString() : this.latestCreatedIso;

            const latestUpdated = finalArr
                .map(a => new Date(a.updated))
                .filter(d => !isNaN(d.getTime()))
                .sort((a, b) => b - a)[0];
            this.latestUpdatedIso = latestUpdated ? latestUpdated.toISOString() : this.latestUpdatedIso;

            // const latestOverall = [latestCreated, latestUpdated]
            //     .filter(Boolean)
            //     .sort((a, b) => b - a)[0];

            window.dispatchEvent(
                new CustomEvent("blog-last-updated", {detail: {lastUpdated: latestCreated?.toISOString() ?? null}})
            );

            return newItems;
        },
        async fetchFilesForArticles(items) {
            const jobs = (items || [])
                .filter(a => a && a.id != null)
                .map((item) => {
                    const fid = item.id;

                    return this.$services.articleService.fetchFileJson(fid)
                        .then((json) => {
                            const files = Array.isArray(json) ? json : (json ? [json] : []);
                            const idx = this.list.findIndex(x => x && x.id === fid);
                            if (idx !== -1) this.$set(this.list[idx], "_files", files);
                        })
                        .catch((err) => {
                            const idx = this.list.findIndex(x => x && x.id === fid);
                            if (idx !== -1) this.$set(this.list[idx], "_files", []);
                            console.log("fetchFileJson failed for", fid, err);
                        });
                });

            await Promise.all(jobs);
        },
        async loadArticles() {
            this.loading = true;
            try {
                const incoming = await this.fetchArticleList();
                const newItems = this.mergeArticleList(incoming);

                this.$nextTick(() => {
                        this.initFactboxes();
                    }
                );
                await this.fetchFilesForArticles(newItems.length ? newItems : this.list);
            } catch (err) {
                console.error("Failed loading articles", err);
                this.list = [];
            } finally {
                this.loading = false;
            }
        },
        async refreshArticles() {
            try {
                const incoming = await this.fetchArticleList();
                const newItems = this.mergeArticleList(incoming);

                if (newItems.length) {
                    this.$nextTick(() => {
                        this.initFactboxes();
                    });
                    await this.fetchFilesForArticles(newItems);
                }
            } catch (err) {
                console.warn("refreshArticles failed", err);
            }
        },

        bodyWithoutGallery(html) {
            if (!html) return "";
            return String(html).replace(
                /<figure[^>]*class="[^"]*\bgallery-container\b[^"]*"[\s\S]*?<\/figure>/gi,
                ""
            );
        },

        formatDate(value) {
            const d = this.toDate(value);
            if (!d) return "";
            return new Intl.DateTimeFormat("da-DK", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            }).format(d);
        },
        toDate(value) {
            if (!value) return null;
            if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        },
        isGallery(part) {
            return part && String(part.type).toLowerCase() === "gallery";
        },
        filesForPart(part) {
            if (!part) return [];

            if (part._files) return part._files;

            if (Array.isArray(part.json)) {
                this.$set(part, '_files', part.json);
                return part._files;
            }

            if (typeof part.json === 'string' && part.json.trim()) {
                let raw = part.json;
                if (raw.indexOf('&quot;') !== -1) {
                    raw = raw.replace(/&quot;/g, '"');
                }

                try {
                    const parsed = JSON.parse(raw);
                    const arr = Array.isArray(parsed) ? parsed : (parsed ? [parsed] : []);
                    this.$set(part, '_files', arr);
                    return part._files;
                } catch (err) {
                    console.warn('Failed to parse part.json for gallery part', err, part);
                }
            }

            this.$set(part, '_files', []);
            return part._files;
        },
        initFactboxes() {
            this.$nextTick(() => {
                if (!window.$ || !$.fn.collapsibleFactbox) return;

                $(this.$el)
                    .find(".collapsible-factbox")
                    .not(".factbox-initialized")
                    .each(function () {
                        const $el = $(this);

                        try {
                            $el.collapsibleFactbox();
                        } catch (e) {
                            console.warn("collapsibleFactbox error on", $el[0], e);
                        }

                        $el.addClass("factbox-initialized");
                    });
            });
        },
        ensureTwitterWidgets() {
            if (window.twttr && window.twttr.widgets) return Promise.resolve();

            if (this._twitterWidgetsPromise) return this._twitterWidgetsPromise;

            this._twitterWidgetsPromise = new Promise((resolve, reject) => {
                const existing = document.querySelector('script[src="https://platform.twitter.com/widgets.js"]');
                if (existing) {
                    // Script tag exists - wait
                    const check = () => {
                        if (window.twttr && window.twttr.widgets) resolve();
                        else setTimeout(check, 200);
                    };
                    check();
                    return;
                }

                const s = document.createElement("script");
                s.async = true;
                s.src = "https://platform.twitter.com/widgets.js";
                s.charset = "utf-8";
                s.onload = () => resolve();
                s.onerror = (e) => reject(e);
                document.head.appendChild(s);
            });

            return this._twitterWidgetsPromise;
        },
        initTwitterEmbeds() {
            this.$nextTick(() => {
                const root = this.$el;
                if (!root || !root.querySelector('.twitter-tweet')) return;

                this.ensureTwitterWidgets()
                    .then(() => {
                        if (window.twttr && window.twttr.widgets) {
                            window.twttr.widgets.load(root);
                        }
                    })
                    .catch((e) => console.warn("Twitter widgets failed to load", e));
            });
        },
        sanitizePartHtml(html) {
            return String(html).replace(/<script[^>]*platform\.twitter\.com\/widgets\.js[^>]*><\/script>/gi, "");
        },
        ensureIframely() {
            if (window.iframely && typeof window.iframely.load === "function") return Promise.resolve();
            if (this.iframelyPromise) return this.iframelyPromise;

            this.iframelyPromise = new Promise((resolve, reject) => {
                const existing = document.querySelector('script[src="https://cdn.iframe.ly/embed.js"]');
                if (existing) {
                    const check = () => {
                        if (window.iframely && typeof window.iframely.load === "function") resolve();
                        else setTimeout(check, 100);
                    };
                    check();
                    return;
                }

                const s = document.createElement("script");
                s.async = true;
                s.src = "https://cdn.iframe.ly/embed.js";
                s.onload = () => resolve();
                s.onerror = (e) => reject(e);
                document.head.appendChild(s);
            });

            return this.iframelyPromise;
        },

        normalizeIframelyUrls(root) {
            root.querySelectorAll('a[data-iframely-url]').forEach((a) => {
                const v = a.getAttribute("data-iframely-url");
                if (v && v.startsWith("//")) a.setAttribute("data-iframely-url", "https:" + v);
            });
        },

        async renderIframelyEmbeds() {
            const root = this.$el;
            if (!root) return;

            if (!root.querySelector(".iframely-embed a[data-iframely-url]")) return;

            this.normalizeIframelyUrls(root);

            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this._renderIframelyNow();
                });
            });
        },

        async _renderIframelyNow() {
            const root = this.$el;
            if (!root) return;

            try {
                await this.ensureIframely();
                window.iframely.load(root);

                setTimeout(() => {
                    try {
                        window.iframely.load(root);
                    } catch (_) {
                        //Empty catch
                    }
                }, 150);

            } catch (e) {
                console.warn("Iframely render failed", e);
            }
        },
        scheduleIframelyRender() {
            clearTimeout(this.iframelyTimer);
            this.iframelyTimer = setTimeout(() => this.renderIframelyEmbeds(), 50);
        },
        onBreakpointChange(e) {
            this.isDesktop = e.matches;
        },
        setupAdListeners() {
            if (!window.googletag || !googletag.pubads) return;

            googletag.cmd = googletag.cmd || [];
            googletag.cmd.push(() => {
                googletag.pubads().addEventListener("slotRenderEnded", (event) => {
                    const slotId = event.slot.getSlotElementId();
                    this.handleSlotRender(slotId, event.isEmpty);
                });
            });
        },

        handleSlotRender(slotElementId, isEmpty) {
            const labelId = "label-" + slotElementId;
            const labelEl = document.getElementById(labelId);

            if (!labelEl) return;

            // Only show label if ad actually rendered
            labelEl.style.display = isEmpty ? "none" : "block";
        },
        getLatestDate(item) {
            const created = new Date(item.created);
            // const updated = new Date(item.updated);

            // const validCreated = !isNaN(created.getTime()) ? created : null;
            // const validUpdated = !isNaN(updated.getTime()) ? updated : null;

            // const latest = [validCreated, validUpdated]
            //     .filter(Boolean)
            //     .sort((a, b) => b - a)[0];

            return created.toISOString();
        }
    },
};
</script>